import React from 'react';
import UnifiedModal from '../UnifiedModal';
import './ConfirmationModal.css';

/**
 * Confirmation Modal - For delete confirmations, important actions, etc.
 * Replaces the problematic MyBacktest delete modals
 */
const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger', // 'danger', 'warning', 'info', 'success'
  isProcessing = false,
  confirmDisabled = false,
  children, // For custom content beyond message
  ...props
}) => {
  const handleConfirm = () => {
    if (isProcessing || confirmDisabled) return;
    onConfirm();
  };

  const getVariantClass = () => {
    return `confirmation-modal-${variant}`;
  };

  return (
    <UnifiedModal 
      isOpen={isOpen} 
      onClose={onClose} 
      size="sm"
      className={`confirmation-modal ${getVariantClass()}`}
      ariaLabel={title || 'Confirmation dialog'}
      {...props}
    >
      <div className="confirmation-modal-content">
        {title && (
          <div className="confirmation-modal-header">
            <h3 className="confirmation-modal-title">{title}</h3>
          </div>
        )}
        
        <div className="confirmation-modal-body">
          {message && (
            <p className="confirmation-modal-message">{message}</p>
          )}
          {children}
        </div>
        
        <div className="confirmation-modal-actions">
          <button 
            className={`confirmation-btn confirmation-btn-${variant}`}
            onClick={handleConfirm}
            disabled={isProcessing || confirmDisabled}
            data-testid="confirmation-confirm-btn"
          >
            {isProcessing ? 'Processing...' : confirmText}
          </button>
          <button 
            className="confirmation-btn confirmation-btn-cancel"
            onClick={onClose}
            disabled={isProcessing}
            data-testid="confirmation-cancel-btn"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </UnifiedModal>
  );
};

export default ConfirmationModal;